import useKeydown from './useKeydown';

export default (onInterrupt) => {
    useKeydown((e) => {
        const eventObj = window.event ? window.event : e;

        if (eventObj.keyCode === 67 && eventObj.ctrlKey) onInterrupt();
    });
};
